import styled, { keyframes } from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ role }) => (role === 'ai' ? 'flex-start' : 'flex-end')};
  padding: ${({ role }) => (role === 'ai' ? '0 80px 0 0' : '0 0 0 80px')};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  max-width: 800px;
  padding: 10px 14px;
  border-radius: ${({ role }) => (role === 'ai' ? '14px 14px 14px 3px' : '14px 14px 3px 14px')};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme, role }) => (role === 'ai' ? theme.colors.backgroundLite : theme.colors.background)};
  border: 0.5px solid
    ${({ theme, role }) => (role === 'ai' ? `${theme.colors.secondary}30` : `${theme.colors.secondary}50`)};
  font-size: 15px;
  word-wrap: break-word;

  & p {
    margin: 0.3em 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  & strong {
    font-weight: 500;
  }

  & h1,
  & h2,
  & h3,
  & h4,
  & h5,
  & h6 {
    font-weight: 500;
    margin: 20px 12px 0px 0;
    &:first-child {
      margin-top: 0;
    }
  }

  & em {
    font-style: italic;
  }

  & code {
    font-family: 'DM Mono', 'Fira Code', monospace;
    font-size: 12px;
    background-color: ${({ theme }) => theme.colors.background};
    border: 0.5px solid ${({ theme }) => `${theme.colors.secondary}30`};
    color: ${({ theme }) => theme.colors.primary};
    padding: 2px 4px;
    border-radius: 4px;

    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }

  & pre {
    background-color: ${({ theme }) => theme.colors.background};
    border: 0.5px solid ${({ theme }) => `${theme.colors.secondary}30`};
    border-radius: 8px;
    padding: 10px 12px;
    font-family: 'DM Mono', 'Fira Code', monospace;
    font-size: 12px;
    margin: 0.6em 0;

    /* ✅ FIX WRAPPING */
    white-space: pre-wrap; /* allows wrapping */
    word-break: break-word; /* breaks long tokens */
    overflow-wrap: anywhere; /* strongest fallback */

    overflow-x: auto;
  }

  & pre code {
    background: none;
    border: none;
    padding: 0;
    color: ${({ theme }) => theme.colors.primary};
  }

  & ul,
  & ol {
    margin: 8px 0 8px 28px;
    padding: 0;
  }

  & li {
    margin: 6px 0;
  }

  & a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    text-underline-offset: 2px;
    &:hover {
      opacity: 0.7;
    }
  }

  & blockquote {
    border-left: 2px solid ${({ theme }) => `${theme.colors.secondary}60`};
    padding-left: 12px;
    margin: 0.5em 0;
    color: ${({ theme }) => theme.colors.secondaryDark};
    font-style: italic;
    border-radius: 0;
  }

  & hr {
    border: none;
    border-top: 0.5px solid ${({ theme }) => `${theme.colors.secondary}30`};
    margin: 1em 0;
  }

  & table {
    width: 100%;
    border-collapse: collapse;
    margin: 15px 0;
    font-size: 14px;
    border-radius: 10px;
    overflow: hidden;
    border: 0.5px solid ${({ theme }) => `${theme.colors.secondary}30`};
  }

  & th {
    background-color: ${({ theme }) => theme.colors.backgroundLite};
    color: ${({ theme }) => theme.colors.primary};
    padding: 8px 10px;
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    border-bottom: 0.5px solid ${({ theme }) => `${theme.colors.secondary}30`};
  }

  & td {
    padding: 7px 10px;
    border-bottom: 0.5px solid ${({ theme }) => `${theme.colors.secondary}20`};
    background-color: ${({ theme }) => theme.colors.background};
    font-size: 14px;
  }

  & tr:last-child td {
    border-bottom: none;
  }
`

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`

export const Cursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 0.85em;
  background-color: ${({ theme }) => theme?.colors?.primary};
  margin-left: 2px;
  animation: ${blink} 1s step-start infinite;
  vertical-align: text-bottom;
  border-radius: 1px;
  opacity: 0.7;
`
